

























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { filter, includes } from 'lodash';
import { flightService } from '@/services/flight-service';
import { AutoCompleteResult } from '@/models/flight-search';

@Component
export default class CityTextField extends Vue {
  @Prop()
  private value: string;
  @Prop()
  private name: string;

  @Emit('input')
  private select({ value }) {
    return value;
  }

  private async searchAirport(keyword: string, cb) {
    this.$emit('input', keyword);
    if (!keyword) {
      // return cb(this.defaultResult);
      return cb();
    }
    const results = await flightService.searchAirports(keyword);
    cb(results);
  }
}
